//import dayjs from 'dayjs';
import {AM_UserDateTime} from '../../../ApiCenter/API_GET';

export const foderColors = {
    'Source': '#FFCC33',
    'Target': '#FFCC33',
    'Normal': '#FFCC33',
    'UserSource': '#198754',
    'UserTarget': '#0D6EFD',
    'Tag': '#75a4eb',
    'Package': '#7beb75',
}

export const sanitizedSourceFilesPath = (sourceFiles) => {
    // remove starting / or ./
    sourceFiles.forEach((item, index) => {

        if(item.original_fullname){
            const linkStr = String(item.original_fullname);
            const path = linkStr.startsWith('/') ? linkStr.substring(1) : 
            linkStr.startsWith('./') ? linkStr.substring(2) : linkStr
            item.original_fullname = path
        }

    })
    return sourceFiles 
}

export const sanitizedTargetFilesPath = (targetFiles) => {
    
    // remove starting / or ./
    targetFiles.forEach((item, index) => {
        
        if(item.link_string){
            const linkStr = String(item.link_string);
            const path = linkStr.startsWith('/') ? linkStr.substring(1) : 
            linkStr.startsWith('./') ? linkStr.substring(2) : linkStr;
            item.link_string = path;
        } 
    })
    return targetFiles 
}

export const createFolderStructure = (data) => {

    const {sourcePackages, sourceFiles, targetPackages, targetFiles, flatView, type} = data


    const output = [];
    // create Root
    /*if(type === 'full'){*/
        output.push(createObject({permRename: false, permDelete: false}, 'root', '0', null, 'root'))
    /*}*/
    // create Source folder
    
    if(sourcePackages && sourcePackages.length){

        output.push(createObject({permRename: false, permDelete: false}, 'source', 'S1', '0', 'sourceTarget'))
        sourcePackages.forEach(prj => {
            let sourceParent = 'S1'; // parentID 
            let sourceFilterPath = 'Source'; // filterPath (Source)

            if(sourcePackages.length > 1){
                // Create only if there are multiple projects
                const obj = {
                    ...prj,
                    name: prj.project_name,
                }
                output.push(createObject({...obj, permRename: false, permDelete: false}, 'package', `SP${prj.project_id}`, sourceParent, sourceFilterPath, 'Project'))
                sourceParent = `SP${prj.project_id}`
                sourceFilterPath = `${sourceFilterPath}/${prj.project_name}`
            }

            // Cicla i batches e packages
            prj.batches.forEach(btc => {
                btc.packages.forEach(pkg => {

                    if(pkg.package_id){
                        
                        const obj = {
                            ...pkg,
                            name: pkg.upload_description
                        }
                        
                        // Create folder for package - EDITABLE
                        output.push(createObject({...obj, permRename: true, permDelete: true}, 'package', `SPK${pkg.package_id}`, sourceParent, sourceFilterPath, 'Package'))

                        const sourceFilesInPackage = sourceFiles.filter(el => el.package_id === pkg.package_id)
                        const packageFilterPath = `${sourceFilterPath}/${pkg.upload_description}`
                        const packageParent = `SPK${pkg.package_id}`;
                        
                        sourceFilesInPackage.forEach(el => {
                            el.fileCustomId = `sourceMedia${el.id}`
                            if(flatView){   
                                // flat view - EDITABLE
                                output.push(createObject({...el, permRename: false, permDelete: true}, 'packageContent', `SF${el.id}`, packageParent, packageFilterPath));
                            } else {
                                // original path as uploaded
                                if(el.original_fullname && el.original_fullname.includes('/')){
                                    const pathParts = el.original_fullname.split('/');
                                    const fileName = pathParts.pop(); 
                                    
                                    let currentParent = packageParent;
                                    let currentFilterPath = packageFilterPath;
                                    
                                    // create userFolders
                                    pathParts.forEach((folderName, index) => {
                                        const folderId = `${packageParent}_F${index}_${folderName.replace(/[^a-zA-Z0-9]/g, '')}`;
                                        
                                        // check if already exists
                                        const existingFolder = output.find(o => o.id === folderId);
                                        
                                        if(!existingFolder){
                                            const folderObj = {
                                                name: folderName,
                                                creation_date: el.creation_date,
                                                resource_name: el.resource_name,
                                                uploadedStructure: true,
                                                sourceTarget: "Source"
                                            };
                                            output.push(createObject({...folderObj, permRename: false, permDelete: true}, 'package', folderId, currentParent, currentFilterPath));
                                        }
                                        
                                        currentParent = folderId;
                                        currentFilterPath = `${currentFilterPath}/${folderName}`;
                                    });
                                    
                                    // just source filename
                                    const fileObj = {
                                        ...el,
                                        original_fullname: fileName
                                    };
                                    output.push(createObject({...fileObj, permRename: false, permDelete: true}, 'packageContent', `SF${el.id}`, currentParent, currentFilterPath));
                                } else {
                                    // only filename - EDITABLE
                                    output.push(createObject({...el, permRename: false, permDelete: true}, 'packageContent', `SF${el.id}`, packageParent, packageFilterPath));
                                }
                            }
                        })
                    }
                })
            })
        })
    }

    /* target files */
    if(targetPackages.length){
        output.push(createObject({permRename: false, permDelete: false}, 'target', 'T1', '0'))

    

    targetPackages.forEach(prj => {

            let projectParent = 'T1'; // parentID project
            let projectFilterPath = 'Target'; // filterPath project

            if(targetPackages.length > 1){

                const obj = {
                    ...prj,
                    name: prj.project_name,
                }
                output.push(createObject({...obj, permRename: false, permDelete: false}, 'package', `TP${prj.project_id}`, projectParent, projectFilterPath, 'Project'))
                projectParent = `TP${prj.project_id}`
                projectFilterPath = `${projectFilterPath}/${prj.project_name}`
            }

            prj.batches.forEach(btc => {
                let batchParent = projectParent; // Starts from the parent of the project
                let batchFilterPath = projectFilterPath; // Starts from the project filterpath
                
                if(prj.batches.length > 1){

                    const obj = {
                        ...btc,
                        name: btc.batch_name,
                    }
                    output.push(createObject({...obj, permRename: false, permDelete: false}, 'package', `TB${btc.batch_id}`, batchParent, batchFilterPath, 'Batch'))
                    batchParent = `TB${btc.batch_id}`
                    batchFilterPath = `${batchFilterPath}/${btc.batch_name}`
                } 

                btc.scripts.forEach(scr => {
                    let scriptParent = batchParent; // Starts from the batch parent
                    let scriptFilterPath = batchFilterPath; // Parte Dal FilterPath del batch
                    
                    if(btc.scripts.length > 1){
                        const obj = {
                            ...scr,
                            name: scr.script_name,
                        }
                        
                        output.push(createObject({...obj, permRename: false, permDelete: false}, 'package', `TS${scr.script_id}`, scriptParent, scriptFilterPath, "Script"))
                        scriptParent = `TS${scr.script_id}`
                        scriptFilterPath = `${scriptFilterPath}/${scr.script_name}`
                    } 

                    scr.scriptLanguages.forEach(scrl => {

                        let script_language_id = scrl.script_language_id
                        
                        scrl.languages.forEach(lang => {
                            let languageParent = scriptParent; // Starts from the Parent of the script
                            let languageFilterPath = scriptFilterPath; // Starts from the script filterpath
                            
                            if(scr.scriptLanguages.length > 1){
                                // Create language folder only if there are more scriptlaguages
                                const obj = {
                                    ...lang,
                                    name: lang.language_code,
                                }
                
                                output.push(createObject({...obj, permRename: false, permDelete: false}, 'package', `TL${lang.language_id}`, languageParent, languageFilterPath, "Language"))
                                languageParent = `TL${lang.language_id}`
                                languageFilterPath = `${languageFilterPath}/${lang.language_code}`
                            } 

                            lang.items.forEach(item => {
                                if(item.id){
                                    let itemParent = languageParent; // starts from the parent of the language
                                    let itemFilterPath = languageFilterPath; // starts from the language of the language
                                    
                                    if(lang.items.length > 1){

                                        
                                        // Create folder for this item only if there are more items
                                        output.push(createObject({...item, name: item.file_description, permRename: false, permDelete: false}, 'package', `TPK${item.id}`, itemParent, itemFilterPath))
                                        //output.push(createObject(item, 'package', `TPK${item.id}`, itemParent, itemFilterPath))
                                        itemParent = `TPK${item.id}`
                                        itemFilterPath = `${itemFilterPath}/${item.file_description}`
                                    }

                                    const targetFilesInPackage = targetFiles.filter(el => el.target_filetype_id === item.id && el.script_language_id === script_language_id)                            
                                    // Raggruppa i file per tag_id
                                    const filesByTag = {};
                                    targetFilesInPackage.forEach(el => {
                                        const tagId = el.tag_id || 'no_tag';
                                        if(!filesByTag[tagId]){
                                            filesByTag[tagId] = [];
                                        }
                                        filesByTag[tagId].push(el);
                                    });

                                    // Create a folder for each tag and insert the files
                                    Object.keys(filesByTag).forEach(tagId => {
                                        const filesInTag = filesByTag[tagId];
                                        const firstFile = filesInTag[0];

                                        let tagParent = itemParent;
                                        let tagFilterPath = itemFilterPath;
                                        
                                        // Crea sempre la cartella del tag
                                        const tagObj = {
                                            tag_id: firstFile.tag_id,
                                            tag_name: firstFile.tag_name || '[No Tag]',
                                            name: firstFile.tag_name || '[_No Tag]',
                                            creation_date: firstFile.tag_creation_date,
                                            resource_name: firstFile.resource_name,
                                            uploadedStructure: true,
                                        };

                                        
                                        const tagFolderId = `TL${lang.language_id}_TPK${item.id}_TTAG${firstFile.tag_id || 'notag'}`;
                                        output.push(createObject({...tagObj, permRename: firstFile.tag_id === 0 ? false : true, permDelete: firstFile.tag_id === 0 ? false : true}, 'package', tagFolderId, tagParent, tagFilterPath, 'Tag'));
                                        tagParent = tagFolderId;
                                        tagFilterPath = `${tagFilterPath}/${tagObj.name}`;

                                        // Enter the tag files
                                        filesInTag.forEach(el => {

                                            el.fileCustomId = `targetMedia${el.id}`
                                            if(flatView){
                                                // flat - NOT EDITABLE
                                                output.push(createObject({...el, permRename: false, permDelete: true}, 'packageContent', `TF${el.id}`, tagParent, tagFilterPath));
                                            } else {
                                                // Structured view create intermediate folders
                                                if(el.link_string && el.link_string.includes('/')){
                                                    const pathParts = el.link_string.split('/');
                                                    const fileNameWithoutExt = pathParts.pop(); // Last element is the file (without extension)
                                                    const fileName = `${fileNameWithoutExt}${el.file_extension}`; // Add extension
                                                    
                                                    let currentParent = tagParent;
                                                    let currentFilterPath = tagFilterPath;
                                                
                                                // Create intermediate folders
                                                pathParts.forEach((folderName, index) => {
                                                    const folderId = `TL${lang.language_id}_TPK${item.id}_TTAG${el.tag_id || 'notag'}_F${index}_${folderName.replace(/[^a-zA-Z0-9]/g, '')}`;
                                                    
                                                    // Check if the folder already exists
                                                    const existingFolder = output.find(o => o.id === folderId);
                                                    
                                                    if(!existingFolder){
                                                        const folderObj = {
                                                            name: folderName,
                                                            creation_date: el.creation_date,
                                                            resource_name: el.resource_name,
                                                            uploadedStructure: true,
                                                            sourceTarget: "Target"
                                                        }
                                                        output.push(createObject({...folderObj, permRename: false, permDelete: true}, 'package', folderId, currentParent, currentFilterPath));
                                                    }
                                                    
                                                    currentParent = folderId;
                                                    currentFilterPath = `${currentFilterPath}/${folderName}`;
                                                })
                                                
                                                // Create the file with the full name (with extension)
                                                const fileObj = {
                                                    ...el,
                                                    original_fullname: fileName,
                                                    tag_id: el.tag_id
                                                };
                                                
                                                output.push(createObject({...fileObj, permRename: false, permDelete: true}, 'packageContent', `TF${el.id}`, currentParent, currentFilterPath));
                                            } else {
                                                // No path in the name, create the file directly - NOT EDITABLE
                                                const flatFileName = `${el.link_string}${el.file_extension}`;
                                                
                                                output.push(createObject({...el, permRename: false, permDelete: true, tag_id: el.tag_id}, 'packageContent', `TF${el.id}`, tagParent, tagFilterPath));
                                            }
                                        }
                                        })
                                    })
                                }
                            })
                            
                        })
                    })

                })
            })
        })
    }


    // Calculate Haschild, size and datevisible for each element
    output.forEach(item => {
        if (!item.isFile) {
            // Check if there are folders (not files) that have this item as a parent
            const hasChildren = output.some(child => child.parentId === item.id && !child.isFile);
            item.hasChild = hasChildren;
            
            // Calculate total and more recent date of the contained files (recursively)
            const calculateFolderStats = (folderId) => {
                let totalSize = 0;
                let mostRecentDate = null;
                let pendingTr = -1;
                let totalFiles = 0;
                
                output.forEach(child => {
                    if (child.parentId === folderId) {
                        if (child.isFile) {
                            totalSize += child.size || 0;
                            if(pendingTr === -1 && child?.transcription_status !== null) pendingTr = 0;
                            if(child?.transcription_status === 0) pendingTr ++;
                            totalFiles++;
                            // Confronta le date
                            if (child.dateCreated) {
                                const childDate = new Date(child.dateCreated);
                                if (!mostRecentDate || childDate > mostRecentDate) {
                                    mostRecentDate = childDate;
                                }
                            }
                        } else {
                            const childStats = calculateFolderStats(child.id);
                            totalSize += childStats.size;
                            if(childStats.pendingTr > -1) {
                                if(pendingTr === -1) pendingTr = 0;
                                pendingTr += childStats.pendingTr;
                            }
                            totalFiles += childStats.totalFiles;
                            if (childStats.date && (!mostRecentDate || childStats.date > mostRecentDate)) {
                                mostRecentDate = childStats.date;
                            }
                        }
                    }
                });
                
                return { size: totalSize, date: mostRecentDate, pendingTr: pendingTr, totalFiles: totalFiles };
            };
            
            const stats = calculateFolderStats(item.id);
            item.size = stats.size;
            item.pendingTr = stats.pendingTr;
            item.totalFiles = stats.totalFiles;
            
            // Format the most recent date
            if (stats.date) {

                item.dateVisible = AM_UserDateTime(stats.date);
            }
        }
    });

    return output;

}


function createObject(props, elementType, currentId, parentId = 0, parentFilterPath = '', im = null){

    let dateCreated 
    let dateModified
    let filterPath
    let hasChild
    let id 
    let isFile
    let uploadedStructure
    let sourceTarget
    let uploader
    let name
    let size
    let type
    let customData = null
    let dateVisible = null
    let permRename = false
    let permDelete = false

    if(elementType === 'root'){
        dateCreated = null
        dateModified = null
        //dateVisible = dayjs(props.dateVisible).format('D-MMM-YYYY H:mm')
        filterPath = '';
        hasChild = true
        id = currentId
        isFile = false
        parentId = null
        name = 'Project Assets'
        size = null
        type = 'folder'
        im = 'root'
        
    }

    if(['source', 'target'].includes(elementType)){
        dateCreated = null
        dateModified = null
        dateVisible = null // Will be calculated after
        filterPath = '/Project Assets';
        hasChild = true
        id = currentId
        isFile = false
        parentId = parentId
        name = elementType.charAt(0).toUpperCase() + elementType.slice(1)
        size = null
        type = 'folder'
        im = 'sourceTarget'
    }

    if(elementType === 'package'){
        dateCreated = props.creation_date
        dateModified = props.creation_date
        dateVisible = props.creation_date ? AM_UserDateTime(props.creation_date) : null
        filterPath = parentFilterPath;
        hasChild = true // will be calculate after
        id = currentId
        isFile = false
        //parentId = parentId
        uploadedStructure = props?.uploadedStructure
        sourceTarget = props?.sourceTarget
        customData = props
        uploader = props.resource_name
        name = props.name
        size = '' //  will be calculate after
        type = 'folder'
        permRename = props.permRename
        permDelete = props.permDelete    
    }

    if(elementType === "packageContent"){

        dateCreated = props.creation_date
        dateModified = props.creation_date
        dateVisible = AM_UserDateTime(props.creation_date)
        filterPath = parentFilterPath;
        hasChild = false
        id = props.fileCustomId
        isFile = true
        //parentId = parentId
        customData = props
        uploader = props.resource_name
        name = props?.original_fullname && props?.original_fullname !== "" ? props?.original_fullname : `${props.link_string}${props.file_extension}`
        size = parseInt(props.file_size/1024)
        type = props.file_extension === '.mov' ? '.mp4' : props.file_extension
        permRename = props.permRename
        permDelete = props.permDelete

    }

    return {
        dateCreated,
        dateModified,
        dateVisible,
        uploadedStructure,
        sourceTarget,
        filterPath,
        hasChild,
        id,
        isFile,
        name,
        uploader,
        parentId,
        customData, 
        size,
        type,
        im,
        permRename,
        permDelete,
        transcription_text: props.transcription_text ?? null,
        transcription_status: props.transcription_status ?? null,
    }

}


// style for fullpath
export const pathSeparator = (pathString) => {

    const pathStringEdited = pathString.split('/')
  
    return pathStringEdited.map((item, index) => (
        <span key={index}>
            <span className="path-item">{item}</span>
            {index < pathStringEdited.length - 1 && <span className="path-separator"> / </span>}
        </span>
    ))
}


